// 小程序配置
export const MINI_PROGRAM_CONFIG = {
  appId: 'wx93067834fa92c862',
  username: 'gh_bb99271de2dd',
  path: 'pages/authorize/index',
  channel: 'gw_miniprogram',
  isMaster: IS_MASTER_ENV,
  redirectUrl: `${encodeURIComponent(window.location.href)}`,
  envVersion: IS_MASTER_ENV ? 'release' : 'trial' //  trial 开发版 release 正式版
};
